import { colors, fonts } from '@grupoboticario/flora-tokens/dist/casaMagalhaesOutono/web/ds'

export const casaMagalhaesOutono = {
  colors,
  fonts,
}
